module.exports = __webpack_public_path__ + "img/badge-network-gold-darkbg.f2b43301.svg";